<groundworks-card>
  <groundworks-card-header [title]="'Job Details'" [titleBadge]="headerBadge()" />
  <groundworks-card-body>
    @switch (state()) {
    @case ('loading') {
    <groundworks-state-message type="loading" message="Loading job details..." class="d-flex" />
    }
    @case ('no-matches') {
    <groundworks-state-message type="no-matches" message="No job for this opportunity." class="d-flex" />
    }
    @case ('error') {
    <groundworks-state-message type="error" message="Error loading job details." class="d-flex" />
    }
    @case ('matches') {
    <div class="row g-3">
      <div class="col-12">
        <groundworks-card [title]="'Job Overview'" [cardClasses]="['shadow-none']">
          <groundworks-card-body>
            <groundworks-term-value [items]="jobDetails()" layout="horizontal" />
          </groundworks-card-body>
        </groundworks-card>
      </div>
    </div>
    <div class="row g-3 mt-0 mb-3">
      <div class="col-12">
        <groundworks-card [cardClasses]="['shadow-none']">
          <groundworks-card-header [title]="'Products'" />
          <groundworks-card-body>
            <div class="row">
              <div [class.col-12]="!hasRightColumnContent()" [class.col-8]="hasRightColumnContent()">
                <div class="table-responsive">
                  <groundworks-table [data]="installableTableData()" />
                </div>
              </div>
              @if (hasRightColumnContent()) {
              <div class="col-4 d-flex flex-column gap-4">
                @if (hasNonInstallableProducts()) {
                <div class="table-responsive">
                  <groundworks-table [data]="nonInstallableTableData()" />
                </div>
                }
                @if (hasRecurringProducts()) {
                <div class="table-responsive">
                  <groundworks-table [data]="recurringTableData()" />
                </div>
                }
                @if (hasTax() && taxTableData()) {
                <div class="table-responsive">
                  <groundworks-table [data]="taxTableData()!" />
                </div>
                }
              </div>
              }
            </div>
          </groundworks-card-body>
        </groundworks-card>
      </div>
    </div>
    }
    }
  </groundworks-card-body>
  @if (configService.showJobActions) {
  <groundworks-card-actions [actions]="jobActions" />
  }
</groundworks-card>
